module.exports = __webpack_public_path__ + "static/media/Logo__Adobe.633dca86.svg";